export default __webpack_public_path__ + "static/media/BrandAmbassador1.86ad01fa.jpg";